module.exports = __webpack_public_path__ + "img/2.7044b652.jpg";